import { def } from '@goldblack/shared';

function stringToColor(string) {
    return 'primary.main';
}

function stringToDisplay(string) {
    if (!string) {
        return ``;
    }
    let splits = string.split(' ');
    let result = splits.length === 1 ? `${splits[0][0]}` : `${splits[0][0]}${splits[1][0]}`;
    return result.toUpperCase();
}

function compareUser(user1, user2) {
    return user1._id === user2._id;
}

function getButtonLabel(button) {
    let label = '';
    switch (button) {
        default:
            break;
        case def.UserButtonState.FOLLOW:
            label = 'follow';
            break;
        case def.UserButtonState.UNFOLLOW:
            label = 'unfollow';
            break;
    }
    return label;
}

function getAccountTypeString(type) {
    let string = '';
    switch (type) {
        case def.AccountType.USER:
            string = 'User';
            break;
        case def.AccountType.MODERATOR:
            string = 'Moderator';
            break;
        case def.AccountType.ADMIN:
            string = 'Admin';
            break;
        case def.AccountType.SUPERADMIN:
            string = 'SuperAdmin';
            break;
        default:
            break;
    }
    return string;
}

function getAccountType(string) {
    let type = -1;
    switch (string) {
        case 'User':
            type = def.AccountType.USER;
            break;
        case 'Moderator':
            type = def.AccountType.MODERATOR;
            break;
        case 'Admin':
            type = def.AccountType.ADMIN;
            break;
        case 'SuperAdmin':
            type = def.AccountType.SUPERADMIN;
            break;
        default:
            break;
    }
    return type;
}

function getUserStatusString(type) {
    let string = '';
    switch (type) {
        case def.UserStatus.ACTIVE:
            string = 'Active';
            break;
        case def.UserStatus.INACTIVE:
            string = 'Inactive';
            break;
        case def.UserStatus.INVISIBLE:
            string = 'Invisible';
            break;
        case def.UserStatus.BLOCKED:
            string = 'Blocked';
            break;
        case def.UserStatus.NOT_VERIFIED:
            string = 'NotVerfifed';
            break;
        default:
            break;
    }
    return string;
}

function getUserStatus(string) {
    let status = -1;
    switch (string) {
        case 'Active':
            status = def.UserStatus.ACTIVE;
            break;
        case 'Inactive':
            status = def.UserStatus.INACTIVE;
            break;
        case 'Blocked':
            status = def.UserStatus.BLOCKED;
            break;
        default:
            break;
    }
    return status;
}

function getUserBlockReasonString(reason) {
    let string = '';
    switch (reason) {
        case def.UserBlockReasons.MAX_FOLLOWING_HIT:
            string = 'Max following hit';
            break;
        case def.UserBlockReasons.MAX_CHATMESSAGE_HIT:
            string = 'Max chat message hit';
            break;
        case def.UserBlockReasons.FAKE_PROFILE_OR_SCAMMER:
            string = 'Fake profile or scammer';
            break;
        case def.UserBlockReasons.FAKE_OR_AI_GENERATED_PHOTO:
            string = 'Fake or AI generated photo';
            break;
        case def.UserBlockReasons.NUDITY_OR_SEXUALLY_EXPLICIT:
            string = 'Nudity or sexually explicit';
            break;
        case def.UserBlockReasons.NOT_A_PHOTO_OF_THIS_USER:
            string = 'Not a photo of this user';
            break;
        default:
            break;
    }
    return string;
}

function getFilterStatusString(type) {
    let string = '';
    switch (type) {
        case def.FilterStatus.ACTIVE:
            string = 'Active';
            break;
        case def.FilterStatus.INACTIVE:
            string = 'Inactive';
            break;
        default:
            break;
    }
    return string;
}

function getBadgeStatusString(type) {
    let string = '';
    switch (type) {
        case def.BadgeStatus.ACTIVE:
            string = 'Active';
            break;
        case def.BadgeStatus.INACTIVE:
            string = 'Inactive';
            break;
        default:
            break;
    }
    return string;
}

function getBoolString(value) {
    return value ? 'True' : 'False';
}

function checkValidationEmail(email) {
    var regex =
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|.('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}

function checkValidationPassword(password) {
    // number, uppercase, lowercase...8 >= length
    var regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return regex.test(password);
}

function checkValidationUsername(name) {
    // lowercase, number, dot, underscore, no space, 3-30
    var regex = /^[^-\s][a-z0-9._]{3,30}$/;
    return regex.test(name);
}

function checkValidationProfilename(name) {
    // alphabet, number, dot, underscore, space, 0-60
    var regex = /^[a-zA-Z0-9._ ]{0,60}$/;
    return regex.test(name);
}

function checkValidationVerificationCode(code) {
    // number, 6 digits
    var regex = /^[0-9]{6}$/;
    return regex.test(code);
}

function getFileExtension(filename) {
    var re = /(?:\.([^.]+))?$/;
    return re.exec(filename)[1];
}

function getContentType(filename) {
    let ext = getFileExtension(filename);
    let type = '';

    switch (ext) {
        case 'mp4':
            type = 'video/mp4';
            break;
        case 'png':
            type = 'image/png';
            break;
        case 'jpg':
        case 'jpeg':
            type = 'image/jpeg';
            break;
        default:
            break;
    }
    return type;
}

function commaNumber(number) {
    return number.toLocaleString('en-US');
}

function formatNumber(num, digits) {
    const lookup = [
        { value: 1, symbol: '' },
        { value: 1e3, symbol: 'K' },
        { value: 1e6, symbol: 'M' },
        { value: 1e9, symbol: 'G' },
        { value: 1e12, symbol: 'T' },
        { value: 1e15, symbol: 'P' },
        { value: 1e18, symbol: 'E' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
        .slice()
        .reverse()
        .find(function (item) {
            return num >= item.value;
        });
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
}

/*
function vhToPx(vh) {
    return document.documentElement.clientHeight * vh / 100;
}*/

function pxToVh(px) {
    return (px / document.documentElement.clientHeight) * 100;
}

function formatVhString(vh) {
    return `${vh}vh`;
}

function formatPxString(px) {
    return `${px}px`;
}

function disableContextMenu(event) {
    event.preventDefault();
}

function parseDeepLink(url) {
    const withoutScheme = url.replace(/^[a-z][a-z0-9+\-.]*:\/\//i, '');
    const [pathStr, queryStr] = withoutScheme.split('?');
    return {
        path: pathStr.split('/').filter(Boolean),
        params: Object.fromEntries(new URLSearchParams(queryStr ?? '')),
        _key: Date.now(),
    };
}

const adminDeepLink = {
    loise: {
        users: {
            search: (params) => `admin://loise/users/search?${new URLSearchParams(params)}`,
        },
    },
    console: {
        run: (cmd) => `admin://console?${new URLSearchParams({ cmd })}`,
    },
};

function formatStringArray(format, values) {
    return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof values[number] != 'undefined' ? values[number] : match;
    });
}

function formatString(format, ...values) {
    return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof values[number] != 'undefined' ? values[number] : match;
    });
}

function getSplitter(format) {
    return format
        .replace(/{(\d+)}/g, function (match, number) {
            return ' ';
        })
        .trim();
}

function scanString(format, value) {
    let splitter = getSplitter(format);
    return splitter !== ''
        ? value.split(splitter).map(function (item) {
              return item.trim();
          })
        : value;
}

// use if object have multi-dimensional array
function cloneObject(obj) {
    if (Array.isArray(obj)) {
        return JSON.parse(JSON.stringify(obj));
    }
    let newObj = {};
    let keys = Object.keys(obj);
    let values = Object.values(obj);
    let length = keys.length;
    for (let i = 0; i < length; ++i) {
        let key = keys[i];
        // if the array is nested or multi-dimensional, deep copy
        if (Array.isArray(values[i])) {
            newObj[key] = cloneObject(values[i]);
        } else {
            newObj[key] = values[i];
        }
    }
    return newObj;
}

function randomUUID() {
    return window.crypto.randomUUID();
}

function getLocaleDateString(date) {
    let newDate = new Date(Date.parse(date));
    return newDate.toLocaleString('ko-KR');
}

function stringToHash(string) {
    let hash = 0,
        i,
        chr;
    if (string.length === 0) {
        return hash;
    }
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export {
    stringToDisplay,
    stringToColor,
    compareUser,
    getButtonLabel,
    getFilterStatusString,
    getBadgeStatusString,
    getLocaleDateString,
    getAccountTypeString,
    getAccountType,
    getUserStatusString,
    getUserStatus,
    getUserBlockReasonString,
    getBoolString,
    checkValidationEmail,
    checkValidationPassword,
    checkValidationUsername,
    checkValidationProfilename,
    checkValidationVerificationCode,
    formatNumber,
    commaNumber,
    formatVhString,
    formatPxString,
    disableContextMenu,
    formatStringArray,
    formatString,
    getSplitter,
    scanString,
    cloneObject,
    getFileExtension,
    getContentType,
    randomUUID,
    stringToHash,
    parseDeepLink,
    adminDeepLink,
};
